import * as React from 'react';

// Circle version (default)
export default function Base(props) {
  const { width = 150, height = 150, primary = "#0052FF" } = props;
  
  // Base logo is circular, so maintain 1:1 aspect ratio
  const actualHeight = height || width;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={actualHeight}
      viewBox="0 0 48 48">
      <circle 
        cx="24" 
        cy="24" 
        r="24"
        fill={primary}
      />
    </svg>
  );
}

// Square version
export function BaseSquare(props) {
  const { width = 150, height = 150, primary = "#0052FF" } = props;
  
  // Base logo is square, so maintain 1:1 aspect ratio
  const actualHeight = height || width;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={actualHeight}
      viewBox="0 0 1280 1280">
      <path 
        fill={primary}
        d="M0,101.12c0-34.64,0-51.95,6.53-65.28,6.25-12.76,16.56-23.07,29.32-29.32C49.17,0,66.48,0,101.12,0h1077.76c34.63,0,51.96,0,65.28,6.53,12.75,6.25,23.06,16.56,29.32,29.32,6.52,13.32,6.52,30.64,6.52,65.28v1077.76c0,34.63,0,51.96-6.52,65.28-6.26,12.75-16.57,23.06-29.32,29.32-13.32,6.52-30.65,6.52-65.28,6.52H101.12c-34.64,0-51.95,0-65.28-6.52-12.76-6.26-23.07-16.57-29.32-29.32-6.53-13.32-6.53-30.65-6.53-65.28V101.12Z"
      />
    </svg>
  );
}